/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 09:38
 * Desc: 云店设置-入会配置
 */

import { Component, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import type { ElForm } from 'element-ui/types/form';
import BlackListConfig from '../blackListConfig/blacklistConfig.vue';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import baseAPIService from '@/services/base/baseAPIService';
import { Functions } from '@/library/utils/functions';
import linkMiniPage from '@/views/components/linkForm/miniPage';
import Upload from '@/views/components/upload/upload.vue';
import { noop } from '@/util';
import validateParams from '@/library/utils/paramFilter';

interface BaseConfig {
  showNumberRows?: number;
  defaultShippingPrice?: number;
  isFilterRobot?: number;
  freeType?: number;
  typePrice?: number;
  sgName?: string;
  operationMode?: number;
  actName?: string;
  appName?: string;
  wxAppId?: string | number;
  wxMchid?: string | number;
  platformVersion?: number;
  memberIdent?: number;
}

export enum operationMode {
  UNCONFIG = 0,
  JINGXIANGDAIN,
  YUNSHANGCHENG,
}

export enum isMoreSite {
  DANDIAN,
  QIANDIAN,
}

@Component({
  components: {
    Upload,
    BlackListConfig,
  },
})
export default class RecuitConfig extends Vue {
  /* 数据 */

  $refs: {
    form: ElForm;
  };

  vshow = false;
  /**
   * corpId
   */
  public corpId = baseAPIService.resolveCorpId();

  /**
   * 图片上传地址
   * @type {string}
   */
  public fileTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 当前图片索引
   * @type {number}
   */
  public curPicIndex = 0;

  /**
   * 当前要放大的图片
   * @type {string}
   */
  public curPic = '';

  displayModel = 0;
  /**
   * 图片放大弹窗是否显示
   * @type {boolean}
   */
  public isMagnifyPopShow = false;

  /**
   * 表单数据
   * @type {ItemObject}
   */
  public formData: ItemObject = {
    enterPicture: [],
    typePrice: 0,
    defaultShippingPrice: 0,
    sgName: '',
    operationMode: '',
    CRMAccount: '',
    address: '',
    memberIdent: 1,
    showNumberRows: 1,
    isFilterRobot: 1,
    freeType: 0,
    cstServiceConfig: {
      type: 0,
      qwConfig: {
        id: '',
        link: '',
      },
    },
    // isOpenSplit: false,
    appName: '',
    wxAppId: '',
    wxMchId: 16606259203,
    platformVersion: 1,
    actId: 0,
    actName: '',
    stockType: 2,
    list: [],
    isOpenCst: 1, // 到店计算佣金 0不计算 1计算
    shareCacheTime: '', // 分享收益时效（小时）
    guiderShareCacheTime: '',
    productListImageFlag: 1, // 商品图片取值 0表示有图+无图都返回 1表示只返回有图商品 2只返回无图商品 3只返回已审核图片的商品
    blacklistConfig: [], // 购买限制
    orderQrcodeConfig: {
      displayConfig: 0,
      qrCode: '',
      qrName: '',
    },
    isDefaultLoading: 1, // 是否默认loading图标 0自定义图标 1默认图标
    loadingPicture: '', // 只有当isDefaultLoading	=0的时候。此字段才有效
  };

  public merchantData = {
    sgId: 0,
    wxPayKey: '', // Api密钥
    file: null,
    wxMchId: '',
  };

  public fileName = '';

  /**
   * 表单验证条件
   * @type {ItemObject}
   */
  public ruleArr: ItemObject = {
    wxMchId: [{ required: true, message: '请输入商户号' }],
    wxPayKey: [{ required: true, message: '请输入商户密钥' }],
    file: [{ required: true, message: '请选择相关文件' }],
  };

  /**
   * 验证规则
   * @type {ItemObject}
   */
  public rules = {
    'sgName': [{ required: true, message: '请输入云店名称', trigger: ['blur', 'change'] }],
    'defaultShippingPrice': [{ required: true, message: '请输入默认运费金额', trigger: ['blur', 'change'] }],
    'typePrice': [{ required: true, message: '请输入指定包邮条件', trigger: ['blur', 'change'] }],
    'enterPicture': [{ required: true, message: '请选择会员章程页面', trigger: 'change' }],
    'shareCacheTime': [{ required: true, message: ' ', trigger: 'change' }],
    'guiderShareCacheTime': [{ required: true, message: ' ', trigger: 'change' }],
    'memberIdent': [{ required: true, message: '请选择认证要求', trigger: 'change' }],
    'loadingPicture': [{ required: true, validator: this.validatePic, trigger: ['change', 'blur'] }],
    'orderQrcodeConfig.qrCode': [{ required: true, message: ' ', trigger: 'change' }],
    'cstServiceConfig.qwConfig.id': [{ required: true, message: ' ', trigger: ['change', 'blur'] }],
    'cstServiceConfig.qwConfig.link': [{ required: true, message: ' ', trigger: ['change', 'blur'] }],
  };

  /**
   * 配置收款商户号
   * @type {boolean}
   */
  public merchantConfigShow = false;

  /**
   * 绑定小程序
   * @type {boolean}
   */
  public bindAppShow = false;

  /**
   * 默认分账时间
   * @type {string}
   */
  public defaultStartTime = '1';

  /**
   * 商户号配置规则
   * @type {ItemOnject}
   */
  public merchantConfigRule = {};

  public isDefault = 0;

  public linkPageName = '';

  public blackPage = 1;

  /* 方法 */

  /**
   * 图片上传之前
   * @param {ItemObject} file
   * @return boolean
   */
  // protected onBeforeUpload(file: ItemObject): boolean {
  //   const isJpg = file.type === "image/jpeg";
  //   const isPng = file.type === "image/png";
  //   const isGif = file.type === "image/gif";
  //   const LtSize = file.size / 1024 <= 300;
  //   if (!isJpg && !isPng && !isGif) {
  //     this.$message.error("上传图片只能是 JPG/JPEG/PNG/GIF 格式!");
  //   }
  //   if (!LtSize) {
  //     this.$message.error("上传图片大小不能超过 300Kb!");
  //   }
  //   return (isJpg || isPng || isGif) && LtSize;
  // }

  public onBeforeShareUpload(file: ItemObject): boolean {
    const isJpg = file.type === 'image/jpeg';
    const isPng = file.type === 'image/png';
    const isGif = file.type === 'image/gif';
    const LtSize = file.size / 1024 <= 2048;
    if (!isJpg && !isPng && !isGif) {
      this.$message.error('上传图片只能是 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!LtSize) {
      this.$message.error('上传图片大小不能超过 2M!');
    }
    return (isJpg || isPng || isGif) && LtSize;
  }

  /**
   * 文件上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  beforeFileUpload(file) {
    if (file.name.split('.')[1] != 'pfx') {
      this.$message.error('上传文件只支持 pfx 格式!');
    } else {
      this.fileName = file.name;
      this.merchantData.file = file;
    }
    return false;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  // protected uploadImgSuccess(res: HttpAPIRetItem<any>, file: any) {
  //   this.formData.enterPicture.push(res.content);
  // }
  public uploadQrCodeSuccess(res: HttpAPIRetItem<any>) {
    this.formData.orderQrcodeConfig.qrCode = res.content;
    this.$refs.form.validateField('orderQrcodeConfig.qrCode', noop);
  }

  public uploadLoadingSuccess(res: HttpAPIRetItem<any>) {
    this.formData.loadingPicture = res.content;
    this.$refs.form.validateField('loadingPicture', noop);
  }

  cstServiceChange(val) {
    if (val) {
      this.rules['cstServiceConfig.qwConfig.id'] = [{ required: true, message: ' ', trigger: ['change', 'blur'] }];
      this.rules['cstServiceConfig.qwConfig.link'] = [{ required: true, message: ' ', trigger: ['change', 'blur'] }];
    } else {
      this.rules['cstServiceConfig.qwConfig.id'] = [{ required: false, message: ' ', trigger: ['change', 'blur'] }];
      this.rules['cstServiceConfig.qwConfig.link'] = [{ required: false, message: ' ', trigger: ['change', 'blur'] }];
    }
  }

  qrCodeChange(val) {
    if (val) {
      this.rules['orderQrcodeConfig.qrCode'] = [{ required: true, message: '请上传二维码图片', trigger: 'change' }];
    } else {
      this.rules['orderQrcodeConfig.qrCode'] = [{ required: false, message: '请上传二维码图片', trigger: 'change' }];
    }
  }

  // 打开配置链接
  openConfigHelp() {
    window.open('https://runsa.yuque.com/help01/zumgti/tdpinczf09ipgrig?singleDoc#');
  }

  loadingChange(val) {
    if (val === 1) {
      this.$set(this.formData, 'loadingPicture', null);
    }
  }

  validatePic(rule, value, callback) {
    if (!value) {
      return callback(new Error('请上传图片'));
    } else {
      callback();
    }
  }

  uploadShareImgSuccess(res: HttpAPIRetItem<any>) {
    this.formData.list.push({
      siId: 0,
      isDefault: 1,
      sort: this.formData.list.length,
      systemPreset: 0,
      imageUrl: res.content,
    });
  }

  /**
   * 重新图片上传成功时的处理
   * @param res
   * @param file
   */
  public onReUploadSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.$set(this.formData.enterPicture, this.curPicIndex, res.content); // 更新视图
  }

  /**
   * 图片上传失败
   * @return null
   */

  public uploadImgError() {
    this.$message.error('图片上传失败');
  }

  /**
   * 获取小程序入会配置
   * @return null
   */
  public onGetRecruitConfig(): void {
    const postParams = {
      sgId: Number.parseInt(this.$route.params.id),
    };
    IPSService.getSiteGroupOtherConfig({ postParams }).then((res: any) => {
      res.list.forEach((v, i) => {
        if (v.isDefault) {
          this.isDefault = i;
        }
      });
      const cstServiceConfig = res.cstServiceConfig;
      const { qwConfig = { id: '', link: '' }, type = 0 } = cstServiceConfig || {};
      this.formData = { ...res, cstServiceConfig: { type, qwConfig } };
      console.log(this.formData);
      for (let i = 0; i < this.formData.blacklistConfig.length; i++) {
        if (!this.formData.blacklistConfig[i].tipText) {
          this.$set(this.formData.blacklistConfig[i], '_display', 1);
        } else {
          this.$set(this.formData.blacklistConfig[i], '_display', 0);
        }
      }
      if (this.formData.wxAppId !== '') {
        this.vshow = true;
      }
      if (!this.formData.orderQrcodeConfig.displayConfig) {
        this.rules['orderQrcodeConfig.qrCode'] = [{ required: false, message: '请上传二维码图片', trigger: 'change' }];
      }
      if (!this.formData.cstServiceConfig.type) {
        this.rules['cstServiceConfig.qwConfig.id'] = [{ required: false, message: ' ', trigger: ['change', 'blur'] }];
        this.rules['cstServiceConfig.qwConfig.link'] = [{ required: false, message: ' ', trigger: ['change', 'blur'] }];
      }
      this.formData.followConfig = this.formData.followConfig
        .split(',')
        .filter(v => !!v)
        .map(val => Number(val));
      res.enterPicture && this.getMiniPage(res.enterPicture);
    });
  }

  public getMiniPage(pageId) {
    IPSService.miniPageInfo({
      postParams: { pageId },
    }).then((response) => {
      this.linkPageName = `[${pageId}]${response.pageName}`;
    });
  }

  /**
   * 保存小程序入会配置
   * @return null
   */
  public onSaveRecruitConfig(): void {
    const result = this.$refs.form.validate();
    const resultb = this.formData.blacklistConfig.map((val, i) => {
      return (this.$refs[`blacklistConfig${i}`][0].$refs['blacklistConfigForm'] as ElForm).validate();
    });
    resultb.unshift(result);
    Promise.all(resultb)
      .then((res) => {
        if (!res.includes(false)) {
          const {
            memberIdent,
            cstServiceConfig,
            enterPicture,
            showNumberRows,
            defaultShippingPrice,
            typePrice,
            isFilterRobot,
            sgName,
            stockType,
            list,
            shareCacheTime,
            guiderShareCacheTime,
            productListImageFlag,
            orderQrcodeConfig,
            isDefaultLoading,
            loadingPicture,
          }
            = this.formData;
          const postParams: GetSiteGroupOtherConfig = {
            sgId: Number.parseInt(this.$route.params.id),
            memberIdent, // 0禁用 1初次进入小程序要求认证 2购买时要求认证
            enterPicture,
            showNumberRows,
            defaultShippingPrice,
            // isOpenSplit: Number(this.formData.isOpenSplit),
            typePrice,
            isFilterRobot,
            sgName,
            stockType,
            list,
            freeType: 1,
            shareCacheTime,
            guiderShareCacheTime,
            productListImageFlag,
            blacklistConfig: validateParams(this.formData.blacklistConfig),
            followConfig: this.formData.followConfig.join(','),
            orderQrcodeConfig,
            isDefaultLoading,
            loadingPicture,
            cstServiceConfig,
          };
          IPSService.saveSiteGroupOtherConfig({ postParams }).then((res) => {
            if (res) {
              this.$message.success('保存成功');
            } else {
              this.$message.error('保存失败');
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /**
   * 保存新增的收款配置
   * @return null
   */
  public onSaveNewPaymentConfig(): void {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      background: 'rgba(0, 0, 0, 0.3)',
    });
    const formData = new FormData();
    formData.append('sgId', Number.parseInt(this.$route.params.id).toString());
    formData.append('wxPayKey', this.merchantData.wxPayKey);
    formData.append('file', this.merchantData.file);
    formData.append('wxMchId', this.merchantData.wxMchId);
    // @ts-expect-error
    (this.$refs.basic as ElForm).validate((valid) => {
      if (valid) {
        IPSService.saveGroupMchId({ formData })
          .then((res) => {
            if (res.data && res.data.content && res.data.content.result) {
              this.$message.success('保存成功');
              loading.close();
              this.merchantConfigShow = false;
              this.formData.wxMchId = this.merchantData.wxMchId;
              // @ts-expect-error
              (this.$refs?.basic as ElForm).resetFields();
            } else {
              loading.close();
              this.$message.error('保存失败');
            }
          })
          .catch(() => {
            loading.close();
            this.$message.error('保存失败,请检查小程序配置');
          });
      } else {
        loading.close();
      }
    });
  }

  /**
   * 取消
   * @return null
   */
  public onCancel() {
    this.$router.go(-1);
  }

  onDelete(index) {
    this.$confirm('确认删除该选项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      if (this.formData.list[index].isDefault) {
        this.formData.list[0].isDefault = 1;
        this.isDefault = 0;
      }
      this.formData.list.splice(index, 1);
    }, noop);
  }

  get getDefaultShareBg() {
    return (this.formData.list.find(v => !!v.isDefault) || {}).imageUrl;
  }

  setDefault(index) {
    this.formData.list = this.formData.list.map((v) => {
      v.isDefault = 0;
      return v;
    });
    this.formData.list[index].isDefault = 1;
  }

  isSystem(val) {
    return !!val.systemPreset;
  }

  onCopy(e) {
    // 复制成功
    this.$message({
      message: '复制成功！',
      type: 'success',
    });
  }

  onError(e) {
    // 复制失败
    this.$message({
      message: '复制失败！',
      type: 'error',
    });
  }

  onMerchantConfigShow() {
    this.merchantData.file = null;
    (this.merchantData.wxPayKey = ''), (this.merchantData.wxMchId = ''), (this.merchantConfigShow = true);
  }

  onSelectEnterPage() {
    linkMiniPage.open({ sgId: Number(this.$route.params.id) }).then((result) => {
      this.formData.enterPicture = result.id;
      this.linkPageName = `[${result.id}]${result.name}`;
      this.$refs.form.validateField('enterPicture', noop);
    }, noop);
  }

  delLinkPage() {
    this.formData.enterPicture = '';
    this.linkPageName = '';
    this.$refs.form.validateField('enterPicture', noop);
  }

  /**
   * 添加购买地限制
   */
  onAddLimit(): void {
    this.formData.blacklistConfig.push({
      longitude: 0,
      latitude: 0,
      maxKm: 0,
      tipText: '',
      _display: 0,
      promptPicture: '',
      node: '',
    });
    this.blackPage = this.formData.blacklistConfig.length;
  }

  /**
   * 删除限制购买地
   * @param index
   */
  onDelLimit(index: number): void {
    this.$confirm(`确认删除位置${index + 1}`, { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.formData.blacklistConfig.splice(index, 1);
        this.blackPage = this.formData.blacklistConfig.length;
      }
    });
  }

  handleCurrentChange(val) {
    this.blackPage = val;
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.onGetRecruitConfig(); // 获取网点组入会配置
  }
}
